module.exports = __webpack_public_path__ + "img/Rent.7d1fb6f6.svg";